use '@use-gpu/wgsl/use/types'::{ SurfaceFragment };

@optional @link fn remap(n: vec3<f32>) -> vec3<f32> { return n; }

@export fn getNormalFragment(
  surface: SurfaceFragment,
) -> vec4<f32> {
  let N: vec3<f32> = normalize(surface.normal.xyz);

  let normal = remap(N);
  let alpha = surface.albedo.a;

  return vec4<f32>(normal, alpha);
}
